import React from 'react';
import { Card, Icon, Typography, Box, useMediaQuery } from 'bonfire-kindling';

const DashboardOverviewContentCard = ({ title, count, iconName, link, children }) => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down('md'));

  return (
    <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ p: 3, display: 'flex', alignItems: 'center' }}>
        <Box sx={{ flex: '1 1 0%', display: 'flex', alignItems: 'center' }}>
          <Icon
            iconName={iconName}
            style={{ fontSize: isMobile ? '1rem' : '1.25rem', marginRight: '0.875rem' }}
          />
          <Typography
            variant="h2"
            component="h2"
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              fontSize: { xs: '1.125rem', md: '1.375rem' },
              marginRight: '0.875rem',
            }}
          >
            {title}
            {count && (
              <Typography
                variant="h2"
                component="span"
                sx={{
                  display: 'inline-block',
                  fontWeight: 'normal',
                  ml: 2,
                  color: theme => theme.palette.brand.grey.grey,
                }}
              >
                {count}
              </Typography>
            )}
          </Typography>
        </Box>
        {link}
      </Box>
      {children}
    </Card>
  );
};

export default DashboardOverviewContentCard;
